<template>
  <v-card outlined color="fondoformulario">
    <v-container>
      <h5>{{titulo}}</h5>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                @keydown.enter.prevent="guardo"
                dense
                outlined
                v-model="selected[propDescripcion]"
                :rules="[RequeridoRules, max50chars]"
                label="Descripcion"
                append-icon="mdi-check-circle"
                @click:append="guardo"
                counter
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    titulo: String,
    modulo: String,
    propId: String,
    propDescripcion: String
  },
  data() {
    return {
      valid: false,
      RequeridoRules: value => !!value || 'Requerido',
      max50chars: v => v.length <= 50 || "Maximo 50 caracteres!"
    };
  },

  computed: {
    selected() {
        return this.$store.state[this.modulo].Seleccionado;
      // this.evitarguardar = false;
      // let nuevo = {};
      // nuevo[this.propId] = 0;
      // nuevo[this.propDescripcion] = "";
      // return nuevo;
    }
  },
  methods: {
    //...mapActions(this.modulo, ["guardar"]),
    guardo() {
      if (this.valid) {
        this.$store.dispatch(this.modulo + "/guardar");
      }
    }
  }
};
</script>

<style>
</style>